const updateFlagged = (objects, id) => {
  let index = objects.findIndex((element) => element.id == id)
  objects[index].flaggedForUpdate = true
  return objects
}

export {updateFlagged}
